/*
 * FAQ accordion — Beam Glow LP family. Document-wide + guarded so it runs once
 * no matter how many sections load it, and wires every .glp-faq on the page.
 */
(function () {
  if (window.__glpFaqLp) return;
  window.__glpFaqLp = true;

  function init() {
    document.querySelectorAll(".glp-faq-q").forEach(function (q) {
      q.addEventListener("click", function () {
        var faq = q.closest(".glp-faq");
        var open = faq.classList.toggle("open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
